import type {
  AppContext,
  AppEvents
} from "@/types/scheduling";

import { produce } from "immer";

export const handleOnSelect = <T extends AppContext, E extends AppEvents>(context: T, event: E, params: { key: string }) => {
  if (event.type === "select") {
    const newContext = produce(context, (draft) => {
      if (params.key === "nutrition_area") {
        draft.result.nutrition_area = event.selection;
      }
      if (params.key === "state") {
        draft.result.state = event.selection;
      }
      if (params.key === "day") {
        draft.result.day = event.selection;
      }
      if (params.key === "communication_style") {
        draft.result.communication_style = event.selection;
      }
      if (params.key === "payment_method") {
        draft.result.payment_method = event.selection;
      }
      if (params.key === "insurance_provider") {
        draft.result.insurance_provider = event.selection;
      }
    });
    return newContext;
  }
  if (event.type === "selectSlot") {
    const newContext = produce(context, (draft) => {
      if (params.key === "slot") {
        draft.result.date_time = event.selection.date_time
        draft.result.provider_id = event.selection.provider_id
        draft.result.is_artificial = event.selection.is_artificial
      }
    });
    return newContext;
  }
  return context
}
